import Layout from "./Shared/Layout";
import '../ComponentCss/myprofile.css';
import { useCallback, useEffect, useState } from "react";
import { get, imageurl, post } from "../_services/apiService";
import toast from "react-hot-toast";
import { API_URL } from "../_services/apiUrl";
import FadeModal from "./Shared/FadeModal";
import Breadcrumb from "./Breadcrumb";



const MyProfile = () => {
    const [customerInfo, setCustomerInfo] = useState(null);

    useEffect(() => {
        const loadCustomerInfo = async () => {
            try {
                const response = await get(API_URL.customerInfo);
                setCustomerInfo(response || null);
            } catch (error) {
                setCustomerInfo(null);
            }
        };

        loadCustomerInfo();
    }, []);




    const updateProfileImage = async (file) => {
        if (!file) return;

        try {
            const formData = new FormData();
            formData.append("image", file);
            const response = await post(API_URL.profileupdate, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            if (response?.message || response?.isSuccess === 200) {
                toast.success("Profile image updated!");

                // refresh data
                const res = await get(API_URL.customerInfo);
                setCustomerInfo(res || null);
            }

        } catch (error) {
            toast.error("Upload error: " + error.message);
        }
    };








    const isLoggedIn = localStorage.getItem("isLoggedIn");
    const [loginDetailById, setLoginDetailById] = useState([]);
    const [show, setShow] = useState(false);

    const onClose = () => {
        setShow(false);
    };


    const GetLoginDetailById = useCallback(async () => {
        try {
            const response = await get(`${API_URL?.GetLoginDetailById}?pLoginDetailId=${isLoggedIn}`);
            if (response.isSuccess === 200) {
                setLoginDetailById(response.data[0]);
            }
        } catch (error) {
            toast.error(error.message);
        }
    }, [isLoggedIn]);

    useEffect(() => {
        GetLoginDetailById();
    }, [GetLoginDetailById])

    const handleIconClick = () => {
        document.getElementById("profile-image-input").click();
    };

    // const handleFileChange = async (e) => {
    //     const file = e.target.files[0];
    //     if (file) {

    //         try {
    //             const formData = new FormData();
    //             formData.append("file", file);
    //             formData.append("isLoggedIn", isLoggedIn);

    //             const response = await post(API_URL?.SaveUserImage, formData, {
    //                 headers: {
    //                     "Content-Type": "multipart/form-data",
    //                 },
    //             });

    //             if (response.isSuccess === 200) {
    //                 toast.success("Profile image uploaded successfully!");
    //                 GetLoginDetailById();
    //             }
    //         } catch (error) {
    //             toast.error("Error uploading image: " + error.message);
    //         }
    //     }
    // };


    return (
        <Layout showBreadcrumb={false}>
            <section className="faqs_main">
                <div className="container-screen pt-sm-4 pt-2 pb-sm-5 pb-2 d-flex justify-content-center">
                    <div className="col-12">
                        {/* Contact Banner Section */}
                        <section className="contact-banner-sec">
                            <div className="container-fluid">
                                <div className="page-header">
                                    <h1>My Profile</h1>
                                </div>
                                <Breadcrumb />
                            </div>
                        </section>

                        <div className="d-flex justify-content-center">
                            <div className="profile-container col-lg-4 col-md-6 col-sm-8 col-11">
                                <div>
                                    <div className="profile_icon_image">
                                        <div className="profile_image">
                                            {/* ➕ Upload Button */}
                                            <p className="mb-0" onClick={handleIconClick}>
                                                <i className="fa fa-plus"></i>
                                            </p>

                                            {/* 🖼 Profile Image */}
                                            {customerInfo?.image_full_url?.path ? (
                                                <img
                                                    src={customerInfo.image_full_url.path}
                                                    alt="UserProfilePicture"
                                                    className="profile-image"
                                                    onClick={() => setShow(true)}
                                                    onError={(e) => {
                                                        e.target.src = "./images/gray-user-profile-icon.png";
                                                    }}
                                                />
                                            ) : (
                                                <img
                                                    src="./images/gray-user-profile-icon.png"
                                                    alt="UserProfilePicture"
                                                    className="profile-image-default"
                                                    onClick={() => setShow(true)}
                                                />
                                            )}

                                            {/* 📂 Hidden Input */}
                                            <input
                                                type="file"
                                                id="profile-image-input"
                                                style={{ display: "none" }}
                                                onChange={(e) => updateProfileImage(e.target.files[0])}
                                                accept="image/*"
                                            />
                                        </div>
                                        <FadeModal show={show} onClose={onClose}>
                                            {customerInfo?.image_full_url?.path ? (
                                                <img
                                                    src={customerInfo?.image_full_url?.path}
                                                    alt="UserProfilePicture"
                                                    className="profile-image-model w-100"
                                                    onError={(e) => {
                                                        e.target.src = "./images/gray-user-profile-icon.png";
                                                    }}
                                                />
                                            ) : (
                                                <img
                                                    src="./images/gray-user-profile-icon.png"
                                                    alt="UserProfilePicture"
                                                    className="profile-image-default-model w-100"
                                                />
                                            )}
                                        </FadeModal>
                                    </div>
                                    <div className="profile-content">
                                        <div className="profile-name"> {customerInfo?.name}</div>
                                        <div className="profile-info">
                                            <span>Mobile :</span> {customerInfo?.phone}
                                        </div>
                                        {/* <div className="profile-info">
                                            <span>Email :</span> {loginDetailById?.emailId}
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout >
    )
}

export default MyProfile;
